module.exports = __webpack_public_path__ + "img/img-6.c9e59d8e.png";